import { Box, Stack } from "@mui/material";
import { Common, Custom } from "components";
import { useTheme } from "contexts";
import { Helpers } from "utils";

type Props = {
  step: number;
  src: string;
  title: string;
  description: string;
};

export const Step = (props: Props) => {
  const { theme } = useTheme();

  return (
    <Box p={theme.spacing.xxl}>
      <Stack gap={theme.spacing.md} alignItems="center">
        <Box mt={1} position="absolute">
          <Custom.Typography
            size={theme.font.md}
            weight={theme.font.semiBold}
            color={theme.color.primary.text}
          >
            {props.step}
          </Custom.Typography>
        </Box>
        <Common.Image
          sx={{ maxWidth: 200 }}
          src={Helpers.getImage(props.src)}
        />
        <Custom.Typography
          align="center"
          size={theme.font.xs}
          weight={theme.font.semiBold}
          color={theme.color.primary.text}
        >
          {props.title}
        </Custom.Typography>
        <Custom.Typography
          align="center"
          size={theme.font.xxs}
          color={theme.color.primary.text}
        >
          {props.description}
        </Custom.Typography>
      </Stack>
    </Box>
  );
};
